import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pinherit(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>
<Helmet>
 
 <title>Learn Free Python Inheritance Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python Inheritance tutorial for beginners.Python Inheritance Class we can create parent class and child class parent class known as Python superclass and Python subclass" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Python Inheritance,Python Inheritance Class,Python Inheritance Example,python inheritance multiple classes,python inheritance  Multiple classes" />
<link rel="canonical" href="https://www.codeexampler.com/python-inheritance" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python Inheritance</h1>

    <div className="first">
        <a href="/python-tuple">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-constructor">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <h2 className="mt-4 mh2">Python Inheritance Class:</h2>
    <p className="mt-4 para"> Python Inheritance Class, we can create parent class and child class parent class known as<span className="bold"> Python superclass</span> and child class known as a<span className="bold"> Python subclass</span>.<br/>
     It allows the creation of hierarchical classifications. <br/>
    You can create a superclass that defines traits common to a set of related items. <br/> Python inheritance class can be inherited by another Class more specific classes.</p>
 



<h2 className='headings'>Q- Write a Program of 2 Student Roll no Marks in Differ Subject Check Toatal Marks and No Percentage on Python Inheritance Examples?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-3">class </span>
                 <span className="qwerty-4">college</span>
                 <span className="qwerty-1">: </span>
             {"\n"}
                 <span className="qwerty-7">    roll_no</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty-4">    a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty-4">    b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty-4">    c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty">    def </span>
                 <span className="qwerty-8">input_data</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">roll_no</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">input</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a roll no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">input</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">input</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter b</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">input</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter c</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">class </span>
                 <span className="qwerty-8">MCA</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">college</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">: </span>
             {"\n"}
                 <span className="qwerty-7">    total_marks</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty-7">    percentage</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty">    def </span>
                 <span className="qwerty-8">per</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">total_marks</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">c</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">percentage</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">total_marks</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-2">100</span>
                 <span className="qwerty">/</span>
                 <span className="qwerty-2">3</span>
             {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">tm of MCA = </span>
                 <span className="qwerty-6">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-5">%self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">total_marks</span>
                 <span className="qwerty-1">)</span>
             
             {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">pr of MCA = </span>
                 <span className="qwerty-6">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-5">%self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">percentage</span>
                 <span className="qwerty-1">)</span>
              
             {"\n"}
                 <span className="qwerty-3">class </span>
                 <span className="qwerty-8">BCA</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">college</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">: </span>
             {"\n"}
                 <span className="qwerty-7">    total_marks</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty-7">    percentage</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
                 <span className="qwerty">    def </span>
                 <span className="qwerty-8">tmt</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">total_marks</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">c</span>
             {"\n"}
                 <span className="qwerty-5">        self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">percentage</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-7">total_marks</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-2">100</span>
                 <span className="qwerty">/</span>
                 <span className="qwerty-2">3</span>
             {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">tm of BCA = </span>
                 <span className="qwerty-6">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-5">%self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">total_marks</span>
                 <span className="qwerty-1">)</span>
        
             {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">pr of BCA = </span>
                 <span className="qwerty-6">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-5">%self</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-4">percentage</span>
                 <span className="qwerty-1">)</span>
    
             {"\n"}
                 <span className="qwerty-4">mc</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-8">MCA</span>
                 <span className="qwerty-1">()</span>
               
             {"\n"}
                 <span className="qwerty-4">bc</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-8">BCA</span>
                 <span className="qwerty-1">()</span>
            
             {"\n"}
                 <span className="qwerty-4">mc</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-6">input_data</span>
                 <span className="qwerty-1">()</span>
             {"\n"}
                 <span className="qwerty-4">mc</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-2">per</span>
                 <span className="qwerty-1">()</span>
             {"\n"}
                 <span className="qwerty-4">bc</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-6">input_data</span>
                 <span className="qwerty-1">()</span>
             {"\n"}
                 <span className="qwerty-4">bc</span>
                 <span className="qwerty">.</span>
                 <span className="qwerty-2">tmt</span>
                 <span className="qwerty-1">()</span>
                 
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
        <h5 className='headings'>Output: </h5>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"100vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-3">Enter a roll no </span>
                 <span className="qwerty-2">4</span>
             {"\n"}
                 <span className="qwerty-4">Enter a </span>
                 <span className="qwerty-2">12</span>
             {"\n"}
                 <span className="qwerty-4">Enter b </span>
                 <span className="qwerty-2">45</span>
             {"\n"}
                 <span className="qwerty-4">Enter c </span>
                 <span className="qwerty-2">39</span>
             {"\n"}
                 <span className="qwerty-10">tm of MCA = </span>
                 <span className="qwerty-7">96</span>
             {"\n"}
                 <span className="qwerty-10">pr of MCA = </span>
                 <span className="qwerty-7">3200</span>
             {"\n"}
                 <span className="qwerty-3">Enter a roll no </span>
                 <span className="qwerty-2">6</span>
             {"\n"}
                 <span className="qwerty-4">Enter a </span>
                 <span className="qwerty-2">15</span>
             {"\n"}
                 <span className="qwerty-4">Enter b </span>
                 <span className="qwerty-2">48</span>
             {"\n"}
                 <span className="qwerty-4">Enter c </span>
                 <span className="qwerty-2">67</span>
             {"\n"}
                 <span className="qwerty-10">tm of BCA = </span>
                 <span className="qwerty-7">130</span>
             {"\n"}
                 <span className="qwerty-10">pr of BCA = </span>
                 <span className="qwerty-7">4333</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  

<h2 className="mt-4 mh2">Types of Python Inheritance:</h2>
<h3 className="mt-4">1, single inheritance<br/>
2, multi-level inheritance<br/>
3, multiple -inheritance<br/>
4,hierarchical-inheritance<br/>
5, hybrid inheritance<br/>
</h3>


  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/python-tuple">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-constructor">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pinherit;